function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Hogar",
  transform: "translate(-55.538 -400.241)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_102",
  "data-name": "Grupo 102"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_101",
  "data-name": "Grupo 101"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_54",
  "data-name": "Trazado 54",
  className: "cls-1",
  d: "M64.344,409.927v4.4H89v-4.4a4.408,4.408,0,0,1,4.4-4.4h.88v-2.642a2.645,2.645,0,0,0-2.642-2.641H61.7a2.645,2.645,0,0,0-2.642,2.641v2.642h.881A4.408,4.408,0,0,1,64.344,409.927Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_55",
  "data-name": "Trazado 55",
  className: "cls-1",
  d: "M95.164,407.285H93.4a2.645,2.645,0,0,0-2.642,2.642v5.283a.881.881,0,0,1-.881.881H63.463a.881.881,0,0,1-.881-.881v-5.283a2.645,2.645,0,0,0-2.641-2.642H58.18a2.645,2.645,0,0,0-2.642,2.642v10.567a2.645,2.645,0,0,0,2.642,2.642h.88v2.641a.882.882,0,0,0,.881.881h5.283a.882.882,0,0,0,.881-.881v-2.641H87.239v2.641a.881.881,0,0,0,.88.881H93.4a.881.881,0,0,0,.88-.881v-2.641h.881a2.645,2.645,0,0,0,2.641-2.642V409.927A2.645,2.645,0,0,0,95.164,407.285Z"
}))));

function SvgHogar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.267,
    height: 26.417,
    viewBox: "0 0 42.267 26.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHogar);
export default __webpack_public_path__ + "static/media/Hogar.7fead275.svg";
export { ForwardRef as ReactComponent };